module.exports = __webpack_public_path__ + "img/puzzle_icon.3c9932da.png";